 const getPrettyDate = (isoString) => {
    const date = new Date(isoString);
    const day = date.getDate();

    // Logic for the suffix
    const suffix = ["th", "st", "nd", "rd"][(day % 10 > 3 || [11, 12, 13].includes(day % 100)) ? 0 : day % 10];

    // Format the rest (February 2026 04:38)
    const options = { month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: true };
    const formattedDate = date.toLocaleDateString('en-GB', options);

    // Combine: 12th February 2026 04:38 AM
    return `${day}${suffix} ${formattedDate.replace(',', '')}`;
  };

export default getPrettyDate;